<template>
  <div class="chart4">
    <div id="Chart4" style="width: 210px; height: 210px"></div>
    <div class="chart4_table">
      <table>
        <tr>
          <th style="width: 80px">资产类别</th>
          <th style="width: 80px">占比规模</th>
          <th style="width: 70px">较上期</th>
        </tr>
        <tr>
          <td class="td1">
            <div class="td_div1"></div>
            股票
          </td>
          <td>88.60%</td>
          <td class="color_red">+88.60%</td>
        </tr>
        <tr>
          <td class="td1">
            <div class="td_div2"></div>
            债券
          </td>
          <td>5.28%</td>
          <td class="color_red">+0.25%</td>
        </tr>
        <tr>
          <td class="td1">
            <div class="td_div3"></div>
            现金
          </td>
          <td>2.08%</td>
          <td class="color_green">-7.74%</td>
        </tr>
        <tr>
          <td class="td1">
            <div class="td_div4"></div>
            其他
          </td>
          <td>0.63%</td>
          <td class="color_red">+0.22%</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts4() {
      var myChart4 = this.$echarts.init(document.getElementById("Chart4"));
      //配置图表
      var option4 = {
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 10,
          top: 0,
        },

        series: [
          {
            type: "pie",
            radius: ["100%", "70%"],
            legendHoverLink: false,
            hoverAnimation: false, //hover放大
            clockwise: true, //true  顺时针   false 逆时针
            label: {
              show: true,
              position: "center",
              formatter: function () {
                return `{a|总收益率} \n {b|6.01%}`;
              },
              rich: {
                a: {
                  fontSize: 17,
                  color: "#999999",
                  lineHeight: 36,
                },
                b: {
                  fontSize: 21,
                  color: "#fcad2a",
                },
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 88.6, name: "股票", itemStyle: { color: "#fcad2a" } },
              { value: 5.28, name: "债券", itemStyle: { color: "#539cff" } },
              { value: 2.08, name: "现金", itemStyle: { color: "#fd4c4c" } },
              { value: 0.63, name: "其他", itemStyle: { color: "#e7e7e7" } },
            ],
          },
        ],
      };
      myChart4.setOption(option4);
    },
  },
  mounted() {
    this.myEcharts4();
  },
};
</script>

<style scoped>
.chart4 {
  display: flex;
}
.chart4_table {
  margin-left: 22px;
}
table tr td {
  line-height: 32px;
  font-size: 14px;
  font-weight: normal;
  color: #333333;
}
table tr th {
  line-height: 44px;
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  color: #666666;
}
.td1 {
  display: flex;
}
.td_div1 {
  width: 12px;
  height: 12px;
  background-color: #fcad2a;
  border-radius: 50%;
  margin-top: 10px;
  margin-right: 7px;
}
.td_div2 {
  width: 12px;
  height: 12px;
  background-color: #539cff;
  border-radius: 50%;
  margin-top: 10px;
  margin-right: 7px;
}
.td_div3 {
  width: 12px;
  height: 12px;
  background-color: #fd4c4c;
  border-radius: 50%;
  margin-top: 10px;
  margin-right: 7px;
}
.td_div4 {
  width: 12px;
  height: 12px;
  background-color: #e7e7e7;
  border-radius: 50%;
  margin-top: 10px;
  margin-right: 7px;
}
.color_red{
  color: #fd4c4c;
}
.color_green{
  color: #41b357;
}
</style>